import React from 'react';

import './show-more-btn.m.css';

const ShowMoreBtn = ({btnName,loadMore}) =>
  <button styleName ="show-more" className="show-more" onClick={loadMore}>{btnName}</button>

export {ShowMoreBtn}
